import { isDevMode } from '@angular/core';
import { Observable, throwError, timer } from 'rxjs';
import { finalize, mergeMap } from 'rxjs/operators';

export const genericRetryStrategy = ({
    maxRetryAttempts = 3,
    scalingDuration = 1000,
    excludedStatusCodes = []
}: {
    maxRetryAttempts?: number,
    scalingDuration?: number,
    excludedStatusCodes?: number[]
} = {}) => (attempts: Observable<any>) => {
    return attempts.pipe(
        mergeMap((error, i) => {
            const retryAttempt = i + 1;
            // if maximum number of retries have been met
            // or response is a status code we don't wish to retry, throw error
            if (retryAttempt > maxRetryAttempts || excludedStatusCodes.find(e => e === error?.status)) {
                return throwError(error);
            }

            const retryTime = retryAttempt * scalingDuration;

            if (isDevMode()) {
                console.log(`Attempt ${retryAttempt}: retrying in ${retryTime}ms`);
            }
            // retry after 1s, 2s, etc...
            return timer(retryTime);
        }),
        finalize(() => {
            if (isDevMode()) {
                console.log('retry completed!');
            }
        })
    );
};
